import type { ActionContext } from 'vuex'

import type { CoreState } from '@/core/store/types'
import type { Location } from '@/core/types'
import { OlympusClient } from '@/OlympusClient'

export interface UpdatePaymentCardSettingsParams {
  locationId: string
  update: {
    paymentCardSettings: Location['paymentCardSettings']
    processing: Location['processing']
  }
}

export const updateLocationPaymentCardSettings = async (
  { commit }: ActionContext<CoreState, unknown>,
  { locationId, update }: UpdatePaymentCardSettingsParams
): Promise<void> => {
  const location = await OlympusClient.locations.location.updateLocation({
    body: update,
    params: {
      locationId,
    },
  })

  commit('SET_LOCATION', location)
}
